export default function CloseIcon({ className = "w-6 h-6" }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.2 10.6154V7.15385C16.2 6.05218 15.7575 4.99563 14.9698 4.21663C14.1822 3.43764 13.1139 3 12 3C10.8861 3 9.8178 3.43764 9.03015 4.21663C8.2425 4.99563 7.8 6.05218 7.8 7.15385V10.6154M7.1 21H16.9C17.457 21 17.9911 20.7812 18.3849 20.3917C18.7788 20.0022 19 19.4739 19 18.9231V12.6923C19 12.1415 18.7788 11.6132 18.3849 11.2237C17.9911 10.8342 17.457 10.6154 16.9 10.6154H7.1C6.54305 10.6154 6.0089 10.8342 5.61508 11.2237C5.22125 11.6132 5 12.1415 5 12.6923V18.9231C5 19.4739 5.22125 20.0022 5.61508 20.3917C6.0089 20.7812 6.54305 21 7.1 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        className={className}
        strokeLinejoin="round"
      />
    </svg>
  );
}
